// Selection ring around the selected system, sized on screen like the system dots.
import type { MapSystem } from '@stars-and-ships/api-types';
import { Container, Graphics } from 'pixi.js';
import { MAP_COLORS } from '../../theme';
import { boxScale, SELECTION_RING } from './systems';

export interface SelectionLayer {
  container: Container;
  setView(scale: number): void;
}

export function selectionLayer(system: MapSystem | undefined): SelectionLayer {
  const container = new Container();
  if (system) {
    container.position.set(system.x, system.y);
    container.addChild(
      new Graphics().circle(0, 0, SELECTION_RING).stroke({
        width: 1,
        color: MAP_COLORS.selected,
        pixelLine: true,
      })
    );
  }
  return {
    container,
    setView(scale) {
      container.scale.set(boxScale(scale));
    },
  };
}
